export const emergencyMenuDef = [
    {
      "name": "menu.emergency_admission",
      "icon": "fa fa-user-md",
      "data": {
        "nav_url": "encounter_erAdmission_m"
      },
      "children": [
        {
          "name": "menu.er_admission",
          "resource": "emergency_format",
          "icon": "fa fa-plus-square",
          "url": "emergency_format",
          "auto_crud": true,
          "breadcrumb": "Admission",
          "check_permission": false
        },
        {
          "name": "menu.er_admission",
          "resource": "encounter_erAdmission",
          "icon": "fa fa-plus-square",
          "url": "encounter_erAdmission",
          "auto_crud": true,
          "breadcrumb": "Admission",
          "showMenu": false
        },
        {
          "name": "menu.transfer_request_list",
          "resource": "encounter_transfer",
          "icon": "fa fa-h-square",
          "url": "encounter_transfer",
          "auto_crud": true,
          "breadcrumb": "Transfer"
        },
        {
          "name": "menu.bed_transferred",
          "resource": "encounter_bedTransfer",
          "icon": "fa fa-h-square",
          "url": "encounter_bedTransfer",
          "auto_crud": true,
          "showMenu": true
        },
       
        {
          "name": "menu.cancel_admission",
          "resource": "encounter_cancelledIpAdmission",
          "icon": "fa fa-h-square",
          "url": "encounter_cancelledIpAdmission",
          "auto_crud": true,
          "showMenu": false
        },
        {
          "name": "menu.initiate_discharge",
          "resource": "encounter_dischargeIpAdmission",
          "icon": "fa fa-h-square",
          "url": "encounter_dischargeIpAdmission",
          "auto_crud": true,
          "showMenu": false
        },
        {
          "name": "menu.encounter_erinitiatedischarge",
          "resource": "encounter_erInitiateDischarge",
          "icon": "fa fa-h-square",
          "url": "encounter_erInitiateDischarge",
          "auto_crud": true,
          "showMenu": false
        }
      ]
    },
    {
      "name": "menu.emergency_registration",
      "icon": "fa fa-user-md",
      "data": {
        "nav_url": "unknown_registration_m"
      },
      "children": [
        {
          "name": "menu.unknown_registration",
          "resource": "unknown_registration",
          "icon": "fa fa-user",
          "url": "unknown_registration",
          "auto_crud": true,
          "breadcrumb": "Unkown Registration"
        }
      ]
    }
  ]